import React, { useState } from "react";
import { Link } from "react-router-dom";
import flyzaLogo from "../assets/flyza-logo.png";
import "./Navbar.css";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <header className="navbar">
        <div className="nav-left">
          <Link to="/" className="logo-link">
            <img src={flyzaLogo} alt="Flyza Logo" className="nav-logo" />
          </Link>

          <button
            className="menu-btn"
            onClick={() => setMenuOpen(true)}
            title="Categories"
          >
            ☰
          </button>
        </div>

        <div className="nav-center">
          <input
            type="text"
            placeholder="Search drones, electronics, robotics..."
            className="search-input"
          />
          <button className="search-btn">Search</button>
        </div>

        <div className="nav-right">
          <Link to="/cart" title="Cart">🛒</Link>
          <Link to="/favorites" title="Favorites">❤️</Link>
          <Link to="/about" title="About">ℹ️</Link>
          <Link to="/rewards" title="Reward Points">⭐</Link>
        </div>
      </header>

      {/* Popup drawer */}
      {menuOpen && (
        <div className="popup-menu">
          {/* ✅ Logo inside popup */}
          <div className="popup-header">
            <img src={flyzaLogo} alt="Flyza Logo" className="popup-logo" />
            <button className="close-btn" onClick={() => setMenuOpen(false)}>✖</button>
          </div>

          <ul>
            <li><Link to="/categories/drone-frame">Drone Frame</Link></li>
            <li><Link to="/categories/motors">Motors</Link></li>
            <li><Link to="/categories/propellers">Propellers</Link></li>
            <li><Link to="/categories/flight-controller">Flight Controller & ESC</Link></li>
            <li><Link to="/categories/battery-strap">Battery Strap</Link></li>
            <li><Link to="/categories/radio-receiver">Radio & Receiver</Link></li>
            <li><Link to="/categories/others">Support 📞</Link></li>
          </ul>
        </div>
      )}
    </>
  );
}

export default Navbar;
